import {
  formatDateTime,
  formatDisplay,
  formatGaugeValue,
} from "../../../common/functions/format";
import { CurrentShip } from "../../../common/states/ship";
import { ShipOperationStatus } from "../../../common/types/ship";
import { EquipMonitoringCard } from "../../atoms/EquipMonitoringCard";
import { ShipMonitoringCard } from "../../atoms/ShipMonitoringCard";
import * as S from "./EquipMonitoringList.style";

interface EquipMonitoringListProps {
  shipOperationStatus?: ShipOperationStatus;
  currentShip?: CurrentShip;
}

export const EquipMonitoringList = ({
  shipOperationStatus,
  currentShip,
}: EquipMonitoringListProps) => {
  const getSatus = (status?: number) => {
    return status === 1 ? true : false;
  };

  const is1000Type = currentShip?.shipTypeName === "1000";

  return (
    <S.EquipMonitoringBox>
      <S.EquipMonitorList $gridColumn={is1000Type ? 3 : 4}>
        <EquipMonitoringCard
          title="No.1 메인엔진"
          status={getSatus(shipOperationStatus?.dashboard37a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard37b)}
          data1={formatDisplay(shipOperationStatus?.dashboard21)}
          data2={formatDisplay(shipOperationStatus?.dashboard22)}
          data3={formatDisplay(shipOperationStatus?.dashboard23)}
          data4={formatDisplay(shipOperationStatus?.dashboard24)}
          cardType="number"
        />
        <EquipMonitoringCard
          title="No.2 메인엔진"
          status={getSatus(shipOperationStatus?.dashboard38a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard38b)}
          data1={formatDisplay(shipOperationStatus?.dashboard25)}
          data2={formatDisplay(shipOperationStatus?.dashboard26)}
          data3={formatDisplay(shipOperationStatus?.dashboard27)}
          data4={formatDisplay(shipOperationStatus?.dashboard28)}
          cardType="number"
        />
        <EquipMonitoringCard
          title="No.3 메인엔진"
          status={getSatus(shipOperationStatus?.dashboard39a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard39b)}
          data1={formatDisplay(shipOperationStatus?.dashboard29)}
          data2={formatDisplay(shipOperationStatus?.dashboard30)}
          data3={formatDisplay(shipOperationStatus?.dashboard31)}
          data4={formatDisplay(shipOperationStatus?.dashboard32)}
          cardType="number"
        />
        {!is1000Type && (
          <EquipMonitoringCard
            title="No.4 메인엔진"
            status={getSatus(shipOperationStatus?.dashboard40a)}
            displayTime={formatDateTime(shipOperationStatus?.dashboard40b)}
            data1={formatDisplay(shipOperationStatus?.dashboard33)}
            data2={formatDisplay(shipOperationStatus?.dashboard34)}
            data3={formatDisplay(shipOperationStatus?.dashboard35)}
            data4={formatDisplay(shipOperationStatus?.dashboard36)}
            cardType="number"
          />
        )}
      </S.EquipMonitorList>
      <S.EquipMonitorList>
        <ShipMonitoringCard shipOperationStatus={shipOperationStatus} />
      </S.EquipMonitorList>

      <S.EquipMonitorList $gridColumn={is1000Type ? 3 : 4}>
        <EquipMonitoringCard
          title="No.1 발전기"
          status={getSatus(shipOperationStatus?.dashboard37a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard37b)}
          data1={formatDisplay(shipOperationStatus?.dashboard21)}
          data2={formatDisplay(shipOperationStatus?.dashboard22)}
          data3={formatDisplay(shipOperationStatus?.dashboard23)}
          data4={formatDisplay(shipOperationStatus?.dashboard24)}
          cardType="number"
        />
        <EquipMonitoringCard
          title="No.2 발전기"
          status={getSatus(shipOperationStatus?.dashboard38a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard38b)}
          data1={formatDisplay(shipOperationStatus?.dashboard25)}
          data2={formatDisplay(shipOperationStatus?.dashboard26)}
          data3={formatDisplay(shipOperationStatus?.dashboard27)}
          data4={formatDisplay(shipOperationStatus?.dashboard28)}
          cardType="number"
        />
        <EquipMonitoringCard
          title="No.3 발전기"
          status={getSatus(shipOperationStatus?.dashboard39a)}
          displayTime={formatDateTime(shipOperationStatus?.dashboard39b)}
          data1={formatDisplay(shipOperationStatus?.dashboard29)}
          data2={formatDisplay(shipOperationStatus?.dashboard30)}
          data3={formatDisplay(shipOperationStatus?.dashboard31)}
          data4={formatDisplay(shipOperationStatus?.dashboard32)}
          cardType="number"
        />
        {!is1000Type && (
          <EquipMonitoringCard
            title="No.4 발전기"
            status={getSatus(shipOperationStatus?.dashboard40a)}
            displayTime={formatDateTime(shipOperationStatus?.dashboard40b)}
            data1={formatDisplay(shipOperationStatus?.dashboard33)}
            data2={formatDisplay(shipOperationStatus?.dashboard34)}
            data3={formatDisplay(shipOperationStatus?.dashboard35)}
            data4={formatDisplay(shipOperationStatus?.dashboard36)}
            cardType="number"
          />
        )}
      </S.EquipMonitorList>
    </S.EquipMonitoringBox>
  );
};
